import { isDefined } from "@clipboard-health/util-ts";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { type UseQueryResult } from "@tanstack/react-query";

import { type BillingSpecialistResponse, billingSpecialistResponseSchema } from "./types";

export interface GetBillingSpecialistParams {
  facilityId?: string;
}

export function useGetBillingSpecialist(
  params: GetBillingSpecialistParams,
  options: UseGetQueryOptions<BillingSpecialistResponse> = {}
): UseQueryResult<BillingSpecialistResponse> {
  const { facilityId } = params;
  return useGetQuery({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/billingSpecialist/${facilityId}`,
    responseSchema: billingSpecialistResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_BILLING_SPECIALIST_FAILURE,
    },
    staleTime: 60 * 1000,
    enabled: isDefined(facilityId),
    useErrorBoundary: false,
    retry: (failureCount, error) =>
      failureCount < 3 && isDefined(error.response) && error.response.status >= 500,
    ...options,
  });
}
